import { DownOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { Divider } from 'antd';
import { cx } from '@emotion/css';
import { formatNumber } from 'utils/numberFormat';

interface OrderProductFooterProps {
  showMore: boolean;
  hasMore: boolean;
  total: number;
  unit: string;
  orderTotalAmount?: number;
  showTotalAmount?: boolean;
  onToggle: () => void;
}

export const OrderProductFooter = (props: OrderProductFooterProps) => {
  const { hasMore, showMore, total, onToggle, orderTotalAmount, unit, showTotalAmount } = props;
  const { t } = useTranslate();

  if (!hasMore && !showTotalAmount) {
    return null;
  }

  return (
    <div
      className={cx(
        'flex items-center text-[#232426] mt-[12px]',
        hasMore ? 'justify-between' : 'justify-end',
      )}
    >
      {hasMore ? (
        <span className="cursor-pointer" onClick={onToggle}>
          {showMore ? t('phrase.收起') : t('other.more')}
          <DownOutlined
            className="text-[#84868C] text-[10px] ml-1"
            style={{
              transform: showMore ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease',
            }}
          />
        </span>
      ) : null}
      {showTotalAmount && (
        <span>
          <span>{t('sidebar.order.product.pieces', { x: total })}</span>
          <Divider type="vertical" />
          <span>
            {unit} {formatNumber(orderTotalAmount, '0,0.00')}
          </span>
        </span>
      )}
    </div>
  );
};
